module.exports = __webpack_public_path__ + "img/carousel-image-1.4c235486.jpg";